import React, { useState } from 'react';
import AIChatPrompt from './AIChatPrompt';

const Hero = ({ stats }) => {
  const [isAIChatOpen, setIsAIChatOpen] = useState(false);

  return (
    <section className="hero">
      <div className="hero-container">
        <div className="hero-content animate-fadeInUp">
          <h1 className="hero-title" style={{ 
            color: '#f64a3e',
            fontFamily: 'Oswald, sans-serif',
            fontSize: '3.5rem',
            fontWeight: '700',
            marginBottom: '1rem',
            textTransform: 'uppercase',
            letterSpacing: '2px'
          }}>
            La Soirée du Rire
          </h1>
          <h2 className="hero-subtitle" style={{ 
            fontSize: '1.5rem', 
            color: '#6E6E6E', 
            marginBottom: '2rem',
            fontWeight: '400',
            fontFamily: 'Oswald, sans-serif',
            textTransform: 'uppercase',
            letterSpacing: '1px'
          }}>
            Tableau de Bord d'Analyses
          </h2>
          <p style={{ 
            fontSize: '1.1rem', 
            color: '#6E6E6E', 
            marginBottom: '2rem',
            lineHeight: '1.6',
            fontFamily: 'Arial, sans-serif'
          }}>
            Suivez les performances de vos réseaux sociaux sur Facebook, Instagram, Google Analytics et Cloudflare avec des insights alimentés par l'IA
          </p>
          <div className="hero-stats">
            <div className="stat-item hover-lift">
              <span className="stat-number" style={{ color: '#f64a3e' }}>{stats.totalFollowers}</span>
              <span className="stat-label">Total Abonnés</span>
            </div>
            <div className="stat-item hover-lift">
              <span className="stat-number" style={{ color: '#f64a3e' }}>{stats.totalViews}</span>
              <span className="stat-label">Total Vues</span>
            </div>
            <div className="stat-item hover-lift">
              <span className="stat-number" style={{ color: '#f64a3e' }}>{stats.engagementRate}</span>
              <span className="stat-label">Taux d'Engagement</span>
            </div>
          </div>
        </div>
        <div className="hero-ai-chat animate-slideInRight">
          <div className="ai-chat-embed">
            <div className="ai-chat-header-embed">
              <div className="ai-avatar-embed">🤖</div>
              <div className="ai-chat-info">
                <h3 style={{ 
                  color: '#f64a3e',
                  fontFamily: 'Oswald, sans-serif',
                  fontSize: '1.2rem',
                  fontWeight: '600',
                  margin: '0',
                  textTransform: 'uppercase',
                  letterSpacing: '1px'
                }}>
                  Assistant IA
                </h3>
                <p style={{ 
                  color: '#6E6E6E',
                  fontSize: '0.9rem',
                  margin: '0',
                  fontFamily: 'Arial, sans-serif'
                }}>
                  La Soirée du Rire
                </p>
              </div>
            </div>
            <div className="ai-chat-preview">
              <div className="ai-message-preview">
                <div className="ai-avatar-small">🤖</div>
                <div className="ai-message-content-preview">
                  Bonjour ! Je suis votre assistant IA pour La Soirée du Rire. Je peux vous aider avec la génération de contenu, les analyses d'engagement et la stratégie des réseaux sociaux.
                </div>
              </div>
            </div>
            <button 
              className="ai-chat-open-btn"
              onClick={() => setIsAIChatOpen(true)}
              style={{
                background: 'linear-gradient(135deg, #f64a3e 0%, #d32f2f 100%)',
                color: 'white',
                border: 'none',
                padding: '12px 24px',
                borderRadius: '8px',
                fontFamily: 'Oswald, sans-serif',
                fontSize: '1rem',
                fontWeight: '600',
                textTransform: 'uppercase',
                letterSpacing: '1px',
                cursor: 'pointer',
                width: '100%',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 15px rgba(246, 74, 62, 0.3)'
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 6px 20px rgba(246, 74, 62, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 4px 15px rgba(246, 74, 62, 0.3)';
              }}
            >
              Ouvrir l'Assistant IA
            </button>
          </div>
        </div>
      </div>
      
      {/* AI Chat Modal */}
      <AIChatPrompt 
        isOpen={isAIChatOpen}
        onClose={() => setIsAIChatOpen(false)}
      />
    </section>
  );
};

export default Hero;
